/* eslint-disable react/jsx-props-no-spreading */
import { FC } from 'react';
import { useTranslate } from 'hooks/useTranslate';

import PendingInvitationLetters from 'modules/beneficiaries/components/PendingInvitationLetters';
import BeneficiaryListMetricsCard from 'modules/beneficiaries/components/BeneficiaryListMetrics/BeneficiaryListMetricsCard';
import { Beneficiary } from 'types';
import BeneficiaryPlanProgressCard from './BeneficiaryPlanProgressCard';

type SummaryRow = {
  sharesTotal: number;
  assignedShares: number;
};

type BeneficiaryPlanMetricsCardProps = {
  summaryRow: SummaryRow;
  percent: number;
  pendingBeneficiaries: Beneficiary[];
  isAdmin: boolean;
};

const BeneficiaryPlanMetricsCard: FC<BeneficiaryPlanMetricsCardProps> = ({
  isAdmin,
  summaryRow,
  percent,
  pendingBeneficiaries,
}) => {
  const { t } = useTranslate();
  const { sharesTotal, assignedShares } = summaryRow;

  return (
    <div className="nk-block mb-4 row">
      <div className="col-12 col-lg-8">
        <div className="card card-bordered card-stretch mb-4 mb-lg-0">
          <div className="card-inner">
            <h6 className="overline-title-alt mb-2">
              <em className="icon ni ni-layers mr-2 fs-20px" />
              {t('UnitsSummary')}
            </h6>

            <div className="row text-center">
              <BeneficiaryListMetricsCard
                title={t('UnitsTotal')}
                value={sharesTotal || 0}
                colSize={3}
              />

              <BeneficiaryListMetricsCard
                title={t('UnitsAssigned')}
                value={assignedShares || 0}
                colSize={3}
              />

              <BeneficiaryListMetricsCard
                title={t('UnitsPending')}
                value={sharesTotal - assignedShares || 0}
                colSize={3}
              />

              <BeneficiaryListMetricsCard
                title={t('PercentagePool')}
                value={percent || 0}
                colSize={3}
                suffix="%"
                useDecimals
              />

              {isAdmin && (
                <PendingInvitationLetters
                  pendingInvitations={pendingBeneficiaries}
                />
              )}
            </div>
          </div>
        </div>
      </div>

      <div className="col-12 col-lg-4">
        <BeneficiaryPlanProgressCard summaryRow={summaryRow} />
      </div>
    </div>
  );
};

export default BeneficiaryPlanMetricsCard;
